module.exports = "<p>\n  test10 works!\n</p>\n"